import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCheckCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import './Notification.css';

/**
 * Individual notification component with modern styling
 */
const Notification = ({ notification, onRemove }) => {
  const { documentId, message, isError } = notification;
  
  // Determine notification type and styling
  const getNotificationProps = () => {
    if (isError) {
      return {
        className: 'notification notification--error',
        icon: faExclamationTriangle,
        iconColor: '#dc3545'
      };
    }
    
    return {
      className: 'notification notification--success',
      icon: faCheckCircle,
      iconColor: '#28a745'
    };
  };

  const { className, icon, iconColor } = getNotificationProps();

  const handleRemove = () => {
    onRemove(documentId);
  };

  return (
    <div className={className}>
      <div className="notification__content">
        <div className="notification__icon">
          <FontAwesomeIcon 
            icon={icon} 
            style={{ color: iconColor }}
          />
        </div>
        
        <div className="notification__body">
          <div className="notification__message">
            {message}
          </div>
        </div>
        
        <button 
          className="notification__close"
          onClick={handleRemove}
          aria-label="Close notification"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>
    </div>
  );
};

export default Notification;
